import axios from "axios";

export default {
  async register({ username, email, password, firstName, lastName }) {
    return axios.post(`/users`, {
      username,
      email,
      password,
      firstName,
      lastName
    });
  },

  async login({ username, password }) {
    return axios.post(`/auth/login`, {
      username,
      password
    });
  }
};
